import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { careersRouteI18n } from '../i18n/careers-route-i18n';

export function careersRoutePath(): string {
  return `/${langRouteI18n()}/${careersRouteI18n()}`;
}
